"use client";

import { RandomizedMapMarkers } from "@/components/common/randomized-map-markers";

interface MapSkeletonProps {
	/** Whether to show the view switcher */
	showViewSwitcher?: boolean;
	/** Whether to show enhanced controls */
	showEnhancedControls?: boolean;
	/** Custom className for the container */
	className?: string;
	/** Position of map controls - bottom spacing */
	controlsBottomSpacing?: string;
}

export function MapSkeleton({
	showViewSwitcher = false,
	className = "",
	// controlsBottomSpacing = "bottom-4",
}: MapSkeletonProps) {
	return (
		<div className={`bg-neutral-100 relative overflow-hidden ${className}`}>
			{/* Full pulsating background */}
			<div className="absolute inset-0 bg-gradient-to-br from-neutral-100 via-neutral-200 to-neutral-300 animate-pulse"></div>

			{/* Map background pattern overlay */}
			<div className="absolute inset-0 bg-gradient-to-br from-neutral-50/50 to-neutral-200/50"></div>

			{/* Stacked FABs Skeleton - Bottom Right */}
			<div className="absolute bottom-4 right-4 z-50 flex flex-col items-center gap-4">
				{/* View Menu FAB Skeleton (Top) */}
				<div className="h-10 w-10 rounded-full bg-black flex items-center justify-center shadow-lg">
					<div className="w-5 h-5 rounded-full border-2 border-white/50" />
				</div>

				{/* Filter FAB Skeleton (Bottom) */}
				<div className="h-10 w-10 rounded-full bg-black flex items-center justify-center shadow-lg border border-white/20">
					<div className="w-4 h-4 rounded-full border-2 border-white/50" />
				</div>
			</div>

			{/* LocationOverlay skeleton - Navigation overlay with location chips */}
			{/* <div className="absolute top-3 left-1/2 z-30 -translate-x-1/2 bg-white/90 backdrop-blur-md rounded-full shadow-lg p-1 max-w-[calc(100dvw-2rem)] overflow-hidden">
				<div className="flex gap-1.5 overflow-x-auto scrollbar-hide"> */}
			{/* Multiple location chips skeleton for richer appearance */}
			{/* <div className="cursor-pointer animate-pulse font-medium whitespace-nowrap rounded-full px-3 py-1 text-xs flex-shrink-0 flex items-center gap-1 border-1 bg-black/60 border-black/60 text-white shadow-md w-20 h-6" />
				</div>
			</div> */}

			{/* FloatingControls skeleton - Filter and share buttons for manual search mode */}
			{/* <div className="absolute top-3 right-3 z-30 flex gap-2"> */}
			{/* Share button skeleton */}
			{/* <div className="bg-white/90 backdrop-blur-md text-black h-8 w-8 rounded-full shadow-lg flex items-center justify-center border-1">
					<div className="w-3.5 h-3.5 bg-gray-400 rounded animate-pulse"></div>
				</div> */}
			{/* Filter button skeleton */}
			{/* <div className="bg-white/90 backdrop-blur-md text-black h-8 w-8 rounded-full shadow-lg flex items-center justify-center border-1">
					<div className="w-3.5 h-3.5 bg-gray-400 rounded animate-pulse"></div>
				</div>
			</div> */}

			{/* Map controls skeleton - Enhanced with multiple controls */}
			{/* <div className={`absolute ${controlsBottomSpacing} right-4 space-y-2 z-30`}> */}
			{/* MapControlsFAB skeleton - Zoom, location, and map type controls */}
			{/* <div className="flex flex-col gap-2 items-end"> */}
			{/* Main FAB button skeleton */}
			{/* <div className="bg-black text-white rounded-full shadow-lg w-8 h-8 flex items-center justify-center"> */}
			{/* Three dots to match MoreHorizontal icon - removed animate-pulse to keep visible */}
			{/* <div className="flex items-center gap-0.5">
							<div className="w-1 h-1 bg-gray-400 rounded-full"></div>
							<div className="w-1 h-1 bg-gray-400 rounded-full"></div>
							<div className="w-1 h-1 bg-gray-400 rounded-full"></div>
						</div>
					</div>
				</div>
			</div> */}

			{/* Randomized property markers skeleton */}
			<div className="absolute inset-0 z-20">
				<RandomizedMapMarkers />
			</div>

			{/* Map grid lines for more realistic appearance */}
			<div className="absolute inset-0 opacity-20">
				{/* Vertical lines */}
				<div className="absolute top-0 bottom-0 left-1/4 w-px bg-neutral-400 animate-pulse"></div>
				<div className="absolute top-0 bottom-0 left-1/2 w-px bg-neutral-400 animate-pulse"></div>
				<div className="absolute top-0 bottom-0 left-3/4 w-px bg-neutral-400 animate-pulse"></div>
				{/* Horizontal lines */}
				<div className="absolute left-0 right-0 top-1/4 h-px bg-neutral-400 animate-pulse"></div>
				<div className="absolute left-0 right-0 top-1/2 h-px bg-neutral-400 animate-pulse"></div>
				<div className="absolute left-0 right-0 top-3/4 h-px bg-neutral-400 animate-pulse"></div>
			</div>
		</div>
	);
}
